import { Vestiging } from "@/entities/vestiging";
import { createColumnHelper } from "@tanstack/react-table";
import { BadgeCol, NameCol, OpeningHoursCol } from "../../shared";
import type { FaciliteitenTableFeatures } from "../../shared/faciliteiten-table-features";

export const createColumns = () => {
    const columnHelper = createColumnHelper<FaciliteitenTableFeatures, Vestiging>();
    return columnHelper.columns([
        columnHelper.accessor("beheerVestiging.vestigingNaam", {
            cell: ({ row }) => <NameCol variant="klantenservice" vestiging={row.original} />,
        }),
        columnHelper.accessor("currentOpeningstijden", {
            cell: ({ row }) => <OpeningHoursCol vestiging={row.original} />,
        }),
        columnHelper.display({
            id: "badge",
            cell: ({ row }) => <BadgeCol vestiging={row.original} />,
        }),
    ]);
};
